<script>
    import TodoList from './TodoList.svelte';
    import Login from './Login.svelte';
    import { onMount } from 'svelte';
    import { auth } from './providers/index.js';
    import './global.css';

    let currentUser = null;
    let isLoading = true;

    // 检查当前用户会话
    onMount(async () => {
        try {
            const { data: { session } } = await auth.getSession();
            currentUser = session?.user || null;
        } catch (error) {
            console.error('获取用户会话失败:', error);
        } finally {
            isLoading = false;
        }

        // 监听认证状态变化
        const subscription = auth.onAuthStateChange(
            async (event, user) => {
                currentUser = user;
            }
        );

        // 组件卸载时清理订阅
        return () => subscription.unsubscribe();
    });

    function handleLoginSuccess(user) {
        currentUser = user;
    }

    function handleLogout() {
        currentUser = null;
    }
</script>

<main>
    {#if isLoading}
        <div class="loading-container">
            <div class="spinner"></div>
            <p>加载中...</p>
        </div>
    {:else if currentUser}
        <div class="app-container">
            <header>
                <h1>📝 Todo List Demo</h1>
                <p>A complete TodoList application built with Svelte</p>
            </header>
            
            <TodoList user={currentUser} on:logout={handleLogout} />
            
            <footer>
                <p>Built with ❤️ using Svelte</p>
            </footer>
        </div>
    {:else}
        <Login onLoginSuccess={handleLoginSuccess} />
    {/if}
</main>

<style>
    main {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        max-width: 800px;
        margin: 0 auto;
        padding: 20px;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        color: #6c757d;
    }

    .spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #e9ecef;
        border-top: 4px solid #007bff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 16px;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .app-container {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    header {
        text-align: center;
        margin-bottom: 40px;
    }

    header h1 {
        color: #2c3e50;
        font-size: 2.5rem;
        margin-bottom: 10px;
    }

    header p {
        color: #7f8c8d;
        font-size: 1.1rem;
    }

    footer {
        margin-top: auto;
        text-align: center;
        padding-top: 40px;
        color: #95a5a6;
    }

    @media (max-width: 600px) {
        main {
            padding: 10px;
        }

        header h1 {
            font-size: 2rem;
        }

        header p {
            font-size: 1rem;
        }
    }
</style>